import { createGLightbox } from './lib/glightbox';

const fly_caseStudy: LegacyModule = {
	init: function () {
		this.cache();
		this.events();
		this.initBlockquotes();
		// this.scrollUpdate();
		this.initGalleries();
		this.initLightbox();
	},

	cache: function () {
		this.$caseStudy = document.getElementById('caseStudy');
		this.$blockquotes = this.$caseStudy.querySelectorAll('.main blockquote');
		this.$galleries = this.$caseStudy.querySelectorAll('.main .gallery');
		this.$share = this.$caseStudy.querySelector('.share');
		this.$shareTrigger = this.$caseStudy.querySelector('.share .reveal');
		this.$twitterShare = this.$caseStudy.querySelector('.twitterShare');
	},

	events: function () {
		// document.addEventListener( 'optimizedScroll', this.scrollUpdate.bind(this) );
		this.$shareTrigger.addEventListener('click', this.openShare.bind(this));
		this.$twitterShare.addEventListener('click', this.openTwitterDialog.bind(this));
	},

	initBlockquotes: function () {
		for (var i = this.$blockquotes.length - 1; i >= 0; i--) {
			var text = this.$blockquotes[i].innerHTML;
			var shareUrl = this.getShareUrl(text);

			var a = this.getTwitterAnchor(shareUrl);
			this.$blockquotes[i].appendChild(a);
		}
	},

	getShareUrl: function (text) {
		text = text.replace(/<(?:.|\n)*?>/gm, '');
		text = encodeURI(text);
		var url = document.location;
		var $shareUrl =
			'https://twitter.com/intent/tweet?text=' + text + '&url=' + url + '&via=freeflysystems';

		return $shareUrl;
	},

	getTwitterAnchor: function (url) {
		var a = document.createElement('a');
		a.setAttribute('href', url);
		a.classList.add('twitterLink');
		a.addEventListener('click', this.openTwitterDialog.bind(this));
		a.innerHTML =
			'<svg width="20.92" height="20.92" viewBox="0 0 20.92 20.92"><use xlink:href="#caseStudyTweet"></use></svg>';
		return a;
	},

	openTwitterDialog: function (e) {
		e.preventDefault();
		var target = e.currentTarget;
		window.open(
			target.href,
			'',
			'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
		);
	},

	// navActive: false,
	// scrollUpdate: function(){
	// 	var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

	// 	if( scrollPosition > 700 && !this.navActive ){
	// 		this.$nav.classList.add('active');
	// 		this.navActive = true;
	// 	}else if( scrollPosition < 700 && this.navActive ){
	// 		this.$nav.classList.remove('active');
	// 		this.navActive = false;
	// 	}
	// },

	initGalleries: function () {
		for (var i = this.$galleries.length - 1; i >= 0; i--) {
			var $gallery = this.$galleries[i];
			this.initGallery($gallery);
		}
	},

	initGallery: function ($gallery) {
		var $cells = $gallery.querySelectorAll('.cell');
		var rowsData = this.getRowData($cells);

		for (var i = rowsData.length - 1; i >= 0; i--) {
			this.setCellHeights($cells, rowsData[i]);
		}
	},

	getRowData: function ($cells) {
		var cellCount = $cells.length;
		var remainder = cellCount % 3;
		var lastRowLength = remainder === 0 ? 3 : 2; //either 2 or 3 cells in the last row
		if (cellCount === 1) {
			lastRowLength = 1; //for galleries with only one cell
		}
		var penultimateRowLength = remainder === 1 ? 2 : 3; //either 2 or 3 cells in penultimate row
		var rowCount = Math.ceil($cells.length / 3);

		var rows = Array();
		for (var i = 0; i < rowCount - 2; i++) {
			var base = i * 3;
			var row = Array(base, base + 1, base + 2);
			rows.push(row);
		}

		if (rowCount > 1) {
			var base = cellCount - penultimateRowLength - lastRowLength;
			var penultimateRow = Array();
			penultimateRow.push(base);
			penultimateRow.push(base + 1);
			if (penultimateRowLength === 3) penultimateRow.push(base + 2);
			rows.push(penultimateRow);
		}

		var base = cellCount - lastRowLength;
		var lastRow = Array();
		lastRow.push(base);
		if (lastRowLength > 1) lastRow.push(base + 1);
		if (lastRowLength === 3) lastRow.push(base + 2);
		rows.push(lastRow);

		//Create a new array with width and height data for each cell
		var rowsData = Array();
		for (var i = rows.length - 1; i >= 0; i--) {
			var rowData = Array();
			for (var j = rows[i].length - 1; j >= 0; j--) {
				var index = rows[i][j];
				var $cell = $cells[index];
				var cellData = {
					i: index,
					width: $cell.querySelector('img').getAttribute('width'),
					height: $cell.querySelector('img').getAttribute('height'),
				};
				rowData.push(cellData);
			}
			rowsData.push(rowData);
		}
		//console.log( rowsData );
		return rowsData;
	},

	setCellHeights: function ($cells, row) {
		var rowCount = row.length;
		if (rowCount === 1) {
			$cells[0].style.width = '100%';
			return;
		}

		//determine shortest cell
		var shortest = 999999;
		for (var i = row.length - 1; i >= 0; i--) {
			shortest = Math.min(shortest, row[i].height);
		}

		//get the total width of the row with minned heights
		var totalWidth = 0;
		for (var i = row.length - 1; i >= 0; i--) {
			var width = row[i].width;
			var height = row[i].height;
			var newWidth = (shortest / height) * width;
			row[i].newWidth = newWidth;
			totalWidth += newWidth;
		}

		var cellPad = totalWidth * 0.01; //one percent of over all width
		var padding = cellPad * row.length;
		totalWidth += padding;

		//calculate and set widths for cells
		for (var i = row.length - 1; i >= 0; i--) {
			var index = row[i].i;
			var percent = ((row[i].newWidth + cellPad) / totalWidth) * 100;
			$cells[index].style.width = percent + '%';
		}
	},

	initLightbox: function () {
		createGLightbox({
			selector: '#caseStudy .lightboxTrigger',
			touchNavigation: true,
			loop: true,
			autoplayVideos: true,
		});
	},

	openShare: function (_e) {
		this.$share.classList.add('active');
	},
};

fly_caseStudy.init();
